import { takeLatest } from 'commons/js/util/promiseUtils'
import * as api from 'commons/js/api'

const submitContactForm = takeLatest((values) => {
    return api.sendContactForm(values)
})

export default submitContactForm
